import type {
  NetworkCategoryPerformance,
  NetworkProductRankingSelectionParams,
} from '@gozoki/api-types'
import { keepPreviousData, type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchNetworkCategoryPerformance } from '../queries/networkCategoryPerformance.queries'

export const useNetworkCategoryPerformance = (
  selection: NetworkProductRankingSelectionParams,
  enabled = true,
): UseQueryResult<NetworkCategoryPerformance, unknown> =>
  useQuery({
    queryKey: [
      'get-network-category-performance',
      selection.storeIds,
      selection.storeAgeFilter,
      selection.ageStoreIds,
      selection.startDate,
      selection.endDate,
      selection.categoryIds,
      selection.indicator,
    ],
    queryFn: () => fetchNetworkCategoryPerformance(selection),
    placeholderData: keepPreviousData,
    enabled,
  })
